export default __webpack_public_path__ + "static/media/film-strip-yellow-title-background.fd27fd6b.png";